import React, { Component } from "react";
// import {Link} from 'react-router-dom'
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";
import { MDBCard, MDBCardBody, MDBRow, MDBCol } from "mdbreact";

import content from "../Helpers/home-content-data";
import ShowMoreText from "react-show-more-text";

class HomeCardDeck extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let cards = content.items.map((item, key) => {
      return (
        <MDBCol md="4" key={key} style={{margin:"2px"}}>
          <MDBCard>
            <MDBCardBody style={{ height: "200px", overflowY: "auto" }}>
              <h5>{item.caption}</h5>
              {/* <MDBCardText style={{textAlign:"justify"}}> */}
              <ShowMoreText
                lines={4}
                more="Show more"
                less="Show less"
                anchorClass=""
                onClick={this.executeOnClick}
                expanded={false}
              >
                <p style={{ textAlign: "justify" }}>{item.description}</p>
              </ShowMoreText>
              {/* </MDBCardText> */}
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      );
    });
    return (
      <div style={{ padding: "10px" }}>
        <MDBRow center>{cards}</MDBRow>
      </div>
    );
  }
}

export default HomeCardDeck;
